import JSZip from "jszip";

export const convertBase64 = (file) => {
  return new Promise((resolve, reject) => {
    const fileReader = new FileReader();
    fileReader.readAsDataURL(file);
    fileReader.onload = () => {
      resolve(fileReader.result);
    };
    fileReader.onerror = (error) => {
      reject(error);
    };
  });
};

export const convertZipFile = async (files, folderName = "dicom", fileName = "upload.zip") => {
  const zip = new JSZip();
  const dirname = zip.folder(folderName);

  for (let i = 0; i < files.length; i++) {
    dirname.file(files[i].name, files[i]); // Pass File directly — no base64 conversion
  }

  const content = await zip.generateAsync({ type: "blob" });
  return new File([content], fileName, {
    lastModified: new Date(),
    type: "application/zip",
  });
};